/**
 * 全局混入，慎用，可单独配置本页面使用的混入
 */
export const Mixin = {
  data() {
    return {

    }
  },
  computed: {
    barheight() {
      return this.$store.state.barHeight + 'px';
    },
    navbarheight() {
      return '4.6rem';
    },
    barh() {
      return (num = 0) => {
        return  num + 'rem';
      }
    },
    btnLimits() {
      let btnList = this.$store.state.user.btns
      return (code) => {
        let index = btnList.findIndex((item) => item.code === code)
        return index > -1
      }
    }
  },
  created() {

  },
  mounted() {},
  methods: {
    //路由跳转
    togo(path, query = {}) {
      if (!path) return;
      this.$router.push({
        path,
        query
      });
    },
    toback() {
      this.$router.replace('/application/matters?key=2&active=todo');
    },
    //时间戳转换日期格式
    formatYearDate(date, type = '-') {
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return date.getFullYear() + type + M;
    },
    formatDate(date, type = '-') {
      // let M = date.getMonth()+1
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return date.getFullYear() + type + M + type + D;
    },
    formatTime(d, showS, zeroS) {
      let Y = d.getFullYear();
      let M = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
      let D = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
      let h = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
      let m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
      let s = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m + (showS ? ':' + (zeroS ? '00' : s) : '')
    },
    fnThrottle(fn, delay, atleast) { //节流函数
      let timer = null;
      let previous = null;
      return function() {
        let now = +new Date()
        if (!previous) previous = now;
        if (atleast && now - previous > atleast) {
          fn();
          previous = now;
          clearTimeout(timer)
        } else {
          clearTimeout(timer)
          timer = setTimeout(() => {
            fn();
            previous = null
          }, delay)
        }
      }
    },
    Debounce(fn, t) {
      let delay = t || 500;
      let timer;
      return function () {
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          timer = null;
          fn.apply(this, args);
        }, delay);
      }
    }
  },
  watch: {

  },
  beforeDestroy() {

  }
}
